"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function push(map, item) {
    map.set(map.size, item);
}
exports.push = push;
